import React from 'react'
import QRCode from 'qrcode.react';
import { formatarReal } from '../../util/numberUtil';
import { connect } from 'react-redux';
import _ from 'lodash';
import { EMPRESA_POLITUR, EMPRESAS_NAO_EXIBIR_DIREITOS_DEVERES } from '../../util/constantsUtil';

export class PaginaReciboReserva extends React.Component {
    constructor(props) {
        super(props);
    }

    exibirDelimitacao() {
        return <React.Fragment>
            <tr className="sup">
                <td colSpan="3" align="center">
                    <b>Delimitação: </b>{this.props.pedido.delimitacao}<br/>
                </td>
            </tr>
        </React.Fragment>
    }

    exibirVendedor() {
        return <React.Fragment>
            <tr className="sup">
                <td colSpan="3" align="center">
                    <b>Vendedor: </b>{this.props.pedido.nomeVendedor}<br/>
                    {this.props.pedido.telefoneVendedor}
                </td>
            </tr>
        </React.Fragment>
    }

    exibirDadosRota(reserva) {
        return <React.Fragment>
            {reserva.idRemarcada ?
                <tr className="top">
                    <td><b>**REMARCAÇÃO</b></td>
                </tr> : null
            }
            <tr className="top">
                <td colSpan="3">Pedido: {reserva.pedidoId}</td>
            </tr>
            <tr>
                <td colSpan="3">Rota: {reserva.rota}</td>
            </tr>
            <tr>
                <td colSpan="3">Prefixo: {reserva.prefixoRota ? reserva.prefixoRota : 'Não informado'}</td>
            </tr>
            <tr>
                <td colSpan="3">Origem: {reserva.descCidadeOrigemAlternativa ? reserva.descCidadeOrigemAlternativa : reserva.descCidadeOrigem}</td>
            </tr>
            <tr>
                <td colSpan="3">Destino: {reserva.descCidadeDestinoAlternativa ? reserva.descCidadeDestinoAlternativa : reserva.descCidadeDestino}</td>
            </tr>
            <tr>
                <td colSpan="3">Data/Hora embarque: {reserva.dataHoraPartida}</td>
            </tr>
            <tr>
                <td colSpan="3">Tipo de Viagem: {reserva.descricaoTipoPreco}</td>
            </tr>
            <tr>
                <td colSpan="3">
                    <b>Plataforma embarque: </b>{reserva.plataformaEmbarque ? reserva.plataformaEmbarque : '' }
                </td>
            </tr>
            <tr className="sup">
                <td colSpan="3" align="left">
                    <b>Local de embarque: </b>{reserva.embarque ? reserva.embarque : '' }
                </td>
            </tr>
        </React.Fragment>
    }

    exibirPassageiro(reserva, exibeCrianca) {
        return <React.Fragment key={reserva.passageiroDto.id}>
            <tr className="top">
                <td colSpan="3">Número do bilhete: {reserva.id}</td>
            </tr>
            <tr>
                <td colSpan="3">Passageiro: {reserva.passageiroDto.nome}</td>
            </tr>
            <tr>
                <td colSpan="3">Poltrona: {reserva.numeroPoltrona}</td>
            </tr>
            <tr>
                <td colSpan="3">Tipo emissão: {reserva.passageiroDto.descTipoEmissao}</td>
            </tr>
            <tr>
                <td colSpan="3">CPF: {reserva.passageiroDto.cpfPassageiro}</td>
            </tr>
            <tr>
                <td colSpan="3">Doc. embarque: {reserva.passageiroDto.documentoComFoto}</td>
            </tr>
            {!exibeCrianca
                ? this.exibirDadosCrianca(reserva.passageiroDto) : null}
        </React.Fragment>
    }

    exibirCriacaColo(passageiro) {
        if (passageiro.criancaDto) {
            return <React.Fragment>
                {this.exibirDadosCrianca(passageiro)}
                <tr align="center">
                    <td colSpan="3">
                        <QRCode style={{
                            width: 80,
                            height: 80,
                        }}
                            value={`${passageiro.criancaDto.id}`} />
                    </td>
                </tr>
            </React.Fragment>
        }
        return null
    }

    exibirDadosCrianca(passageiro) {
        const crianca = passageiro.criancaDto;
        if (crianca) {
            return <React.Fragment>
                <tr className='top'>
                    <td colSpan="3">Criança de colo: {crianca.nome}</td>
                </tr>
                <tr>
                    <td colSpan="3">Poltrona: {passageiro.numeroPoltrona}</td>
                </tr>
                <tr>
                    <td colSpan="3">Data nascimento criança: {crianca.dtNascimentoCrianca}</td>
                </tr>
                <tr>
                    <td colSpan="3">Doc. embarque criança: {crianca.documentoCriacaComFoto}</td>
                </tr>
                {crianca.cpfCrianca
                    ? <tr>
                        <td colSpan="3">CPF criança: {crianca.cpfCrianca}</td>
                    </tr> : null}
            </React.Fragment>
        }
    }

    

    exibirCabecalho(label, nome, cpf, nomeEmpresa, cnpj, endereco, inscricaoEstadual, tipoDocumento, numDocumento) {
        return <React.Fragment>
            <tr>
                <th className="title" colSpan="3">
                    {nomeEmpresa ? nomeEmpresa : this.props.empresaSelecionada.nome}
                    <br/>
                    <strong>CNPJ: </strong><span>{cnpj ? cnpj : this.props.empresaSelecionada.cnpj}</span> <br/>
                    {inscricaoEstadual ? <strong>IE: {inscricaoEstadual}</strong> : ''}
                    {/* eslint-disable-next-line no-undef */}
                    {_.isNil(endereco) ? null :
                        <span className='text-center'>{`
            ${endereco.logradouro ? endereco.logradouro : this.props.empresaSelecionada.endereco.logradouro + ','}
            ${endereco.numero ? endereco.numero : this.props.empresaSelecionada.endereco.numero}
            ${endereco.complemento ? `, ${endereco.complemento}` : `${this.props.empresaSelecionada.endereco.complemento}`}`}
                            {`
             ${endereco.bairro ? endereco.bairro : this.props.empresaSelecionada.endereco.bairro}
             ${endereco.localidade ? '-' + endereco.localidade : this.props.empresaSelecionada.endereco.localidade}
             ${endereco.uf ? '-' + endereco.uf : this.props.empresaSelecionada.endereco.uf}
             `}
                            ,<strong> CEP:</strong>{endereco.cep ? endereco.cep : this.props.empresaSelecionada.endereco.cep}
            </span>
                    }
                </th>
            </tr>
            <tr>
                <th colSpan="3">{this.props.pedido.data}</th>
            </tr>
            <tr>
                <th colSpan="3">
                    {nome} <br/>
                    {label == 'Via do passageiro' && (tipoDocumento == 'PASSAPORTE' || tipoDocumento == 'OUTROS') ? numDocumento : cpf}
                </th>
            </tr>
            <tr>
                <th className="ttu" colSpan="3">
                    <b>{label}</b>
                </th>
            </tr>
        </React.Fragment>
    }

    exibirQrCodeVexado(reserva, via) {
        if (via === 'Cupom de embarque') {
            return <React.Fragment>
                <tr align="center">
                    <td colSpan="3">
                        <QRCode style={{
                            width: 160,
                            height: 160,
                        }}
                                value={reserva.codigoQrcodeEmbarqueMonitrip}/>
                    </td>
                </tr>
            </React.Fragment>
        }

    }

    exibirInformacaoCupom(via, reserva, crianca){
        return <React.Fragment>
            <tbody>
            {this.exibirQrCodeVexado(reserva, via)}
            {this.exibirDadosRota(reserva)}
            </tbody>
            <tfoot>
            {this.exibirTotaisReserva(reserva, crianca)}
            {this.exibirBpe(reserva, via)}
            </tfoot>
        </React.Fragment>
    }

    exibirMensagemAviso() {
        if (this.props.empresaSelecionada.mensagemAvisoBilhete) {
            return <tr className="sup">
                <td colSpan="3">
                    {this.props.empresaSelecionada.mensagemAvisoBilhete}
                </td>
            </tr>
        }
    }

    exibirCamposItinerario(reserva) {
        return <React.Fragment>

        <tr className="sup ttu p--0">
            <td colSpan="3">
                <b>Nome fantasia: {this.props.pedido.nomeFantasiaEmpresa}</b>
            </td>
        </tr>
            <tr>
                <td colSpan="3">Número da rota: {reserva.rotaId}</td>
            </tr>
            <tr>
                <td colSpan="3">Número do itinerário: {reserva.itinerarioId}</td>
            </tr>
            <tr>
                <td colSpan="3">Veículo: {reserva.nomeVeiculo}</td>
            </tr>
            <tr>
                <td colSpan="3">Prestador: {reserva.nomePrestador ? reserva.nomePrestador : 'Frota própria'}</td>
            </tr>
            <tr className="sup">
                <td colSpan="3" align="left">
                    <b>Plataforma embarque: </b>{reserva.plataformaEmbarque ? reserva.plataformaEmbarque : '' }
                </td>
            </tr>
            <tr className="sup">
                <td colSpan="3" align="left">
                    <b>Local de embarque: </b>{reserva.embarque ? reserva.embarque : '' }
                </td>
            </tr>
        </React.Fragment>
    }

    exibirBarcodeVexado(codigo, via, index) {

        if (via === 'Cupom de embarque') {
            return <React.Fragment>
                <tr align='center'>
                    <td colSpan='3'>
                        <img className='barcode'
                            data-format='EAN13'
                            data-value={codigo}
                            data-textmargin='0'
                            data-marginLeft='80'
                            data-marginRight='100'
                            />
                    </td>
                </tr>
                <tr>
                    <td colSpan="3" align="center">
                        <b>Passagem: </b>{`${index + 1}/${this.props.pedido.reservas.length}`}
                    </td>
                </tr>

            </React.Fragment>
        }

    }

    exibirCupom(via, reserva, index, crianca) {
        return <div>
            {this.exibirLimiteCupom()}
            <table className="printer-ticket">
                <thead>
                {!crianca ? this.exibirCabecalho(via, reserva.passageiroDto.nome, reserva.passageiroDto.cpfPassageiro, reserva.nomeEmpresa, reserva.cnpjEmpresa, reserva.endereco, reserva.inscricaoEstadual,
                    reserva.passageiroDto.tipoDocumento, reserva.passageiroDto.documentoComFoto)
                    : this.exibirCabecalho(via, reserva.passageiroDto.criancaDto.nome, reserva.passageiroDto.criancaDto.cpfCrianca)}
                </thead>
                <tbody>
                {this.exibirQrCodeVexado(reserva, via, index)}
                {reserva.numeroBilheteRodoviaria ? this.exibirBarcodeVexado(reserva.numeroBilheteRodoviaria, via, index) : ''}
                {this.exibirDadosRota(reserva, via)}
                {!crianca ? this.exibirPassageiro(reserva, true, via) : this.exibirCriacaColo(reserva.passageiroDto)}
                </tbody>
                <tfoot>
                {this.exibirTotaisReserva(reserva, crianca)}
                {this.exibirVendedor()}

                {via !== 'Via do passageiro' ? this.exibirDelimitacao() : ''}
                {via !== 'Via do passageiro' && via !== 'Cupom de embarque' ? this.exibirCamposItinerario(reserva) : ''}

                {this.exibirBpe(reserva, via)}
                {this.exibirMensagemAviso()}
                </tfoot>
            </table>
            {this.exibirLimiteCupom()}
            {this.linha()}
        </div>
    }

    exibirBilheteEmbarque(via, reserva) {
        return (
            <div>
                {this.exibirLimiteCupom()}
                <table className="printer-ticket">
                    <thead>
                        {this.exibirCabecalhoBilheteEmbarque(via, reserva)}
                    </thead>
                    <tbody>
                        <tr>
                            <td colSpan="3">Empresa: {reserva.nomeEmpresa} - {reserva.dataVenda}</td>
                        </tr>
                        <tr>
                            <td  colSpan="3">Origem: {reserva.descCidadeOrigemAlternativa ? reserva.descCidadeOrigemAlternativa : reserva.descCidadeOrigem}
                            /Destino: {reserva.descCidadeDestinoAlternativa ? reserva.descCidadeDestinoAlternativa : reserva.descCidadeDestino}
                            /Bilhete: {reserva.id}</td>
                        </tr>
                        <tr>
                            <td  colSpan="3">Data/Hora Embarque: {reserva.dataHoraPartida}</td>
                        </tr>
                        <tr>
                            <td  colSpan="3">Número tarifa: {reserva.numeroTarifa} / Código tarifa: {reserva.codigoTarifa} </td>
                        </tr>
                        <tr>
                            <td colSpan="3">Valor: {formatarReal(reserva.taxaEmbarque ? reserva.taxaEmbarque.toString() : '0')}</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        <tr align="center">
                            <td  colSpan="3" style={{marginTop: '10px'}}>
                                <QRCode style={{
                                        width: 160,
                                        height: 160
                                    }}
                                    value={reserva.numeroTarifa}
                                />
                            </td>
                        </tr>
                    </tbody>                    
                </table>
                {this.exibirLimiteCupom()}
                {this.linha()}
            </div>
        )
    }

    exibirCabecalhoBilheteEmbarque(via) {
        return (
            <>
               <tr>
                    <th colSpan="3" style={{textTransform: 'uppercase'}}>{via}</th>
                </tr>             
            </>
        )
    }

    exibirICMS(reserva) {
        if (reserva.icmsDesconto || reserva.aliquotaICMS) {
            return <React.Fragment>ICMS: <span>{reserva.valorICMS ? formatarReal(reserva.valorICMS): ''}</span> {reserva.icmsDesconto ? reserva.icmsDesconto.replace('.', ',')
                : reserva.icmsDesconto} {reserva.aliquotaICMS ? (`${reserva.aliquotaICMS}%`) : ''}</React.Fragment>
        }

    }

    exibirTributos(reserva) {
        if (reserva.outrosDescontos || reserva.outrosTributos) {
            return <React.Fragment>TRIB: {reserva.outrosDescontos ? reserva.outrosDescontos.replace('.', ',')
                : reserva.outrosDescontos} ({reserva.outrosTributos ? reserva.outrosTributos.replace('.', ',')
                    : reserva.outrosTributos}%)</React.Fragment>
        }

    }

    exibirIbsCbs(reserva) {
        if (reserva.aliquotaIBSUF || reserva.aliquotaIBSMun || reserva.aliquotaCBS) {
            return <React.Fragment>
                {reserva.aliquotaIBSUF ? <>IBS-UF: <span>{formatarReal(reserva.valorIBSUF)}</span> ({reserva.aliquotaIBSUF}%)<br/></> : null}
                {reserva.aliquotaIBSMun ? <>IBS-Mun: <span>{formatarReal(reserva.valorIBSMun)}</span> ({reserva.aliquotaIBSMun}%)<br/></> : null}
                {reserva.aliquotaCBS ? <>CBS: <span>{formatarReal(reserva.valorCBS)}</span> ({reserva.aliquotaCBS}%)</> : null}
            </React.Fragment>
        }

    }

    exibirBpe(reserva, via) {
        if (via === 'Cupom de embarque') {
            return null
        }
        if (reserva.transmissaoBpe) {
            return <React.Fragment>
                <tr className="sup">
                    <td colSpan="3" align="center">
                        {this.exibirICMS(reserva)}
                        {this.exibirIbsCbs(reserva)}
                        {this.exibirTributos(reserva)}
                    </td>
                </tr>
                <tr className="ttu">
                    <td colSpan="3" align="center" className="font-sm">
                        (Lei Federal 12.741/2012)
                    </td>
                </tr>
                <br />
                <tr className="ttu">
                    <td colSpan="3" align="center" className="font-sm" style={{ wordWrap: 'break-word' }}>
                        {reserva.transmissaoBpe.urlConsulta}
                    </td>
                </tr>
                <tr className="ttu">
                    <td colSpan="3" align="center" className="font-sm">
                        {reserva.transmissaoBpe.chaveAcesso}
                    </td>
                </tr>
                {reserva.transmissaoBpe.emitidoEmContigencia ? <tr align="center">
                    <td colSpan="3">
                        <QRCode style={{
                           width: 160,
                           height: 160
                        }}
                            value='http://bpeemitidoemcontingencia.log.br/' />
                    </td>
                </tr> : <tr align="center">
                    <td colSpan="3">
                        <QRCode style={{
                            width: 160,
                            height: 160
                        }}
                            value={`${reserva.transmissaoBpe.qrCod}`} />
                    </td>
                </tr>}
                {reserva.transmissaoBpe.emitidoEmContigencia ? <tr align="center">
                    <td colSpan="3">
                        <span style={{ color: 'red' }}>EMITIDO EM CONTINGÊNCIA</span>
                    </td>
                </tr> : null}
            </React.Fragment>
        }
    }

    calcularValorTarifa({ tarifa, desconto }) {
        return Number(tarifa) + Number(desconto)
    }

    calcularValorPago({ taxaServico, valorTotalReserva }) {
        return Number(valorTotalReserva) + Number(taxaServico)
    }

    exibirTotaisReserva(reserva, crianca) {
        return <React.Fragment>{!crianca ? <React.Fragment>
            <tr className="sup ttu p--0">
                <td colSpan="3">
                    <b>Totais</b>
                </td>
            </tr>
            <tr className="ttu">
                <td colSpan="2">Tarifa</td>
                <td align="right">{formatarReal(this.calcularValorTarifa(reserva)
                    .toString())}
                </td>
            </tr>
            <tr className="ttu">
                <td colSpan="2">Taxa de embarque</td>
                <td align="right">{formatarReal(reserva.taxaEmbarque ? reserva.taxaEmbarque.toString() : '0')}</td>
            </tr>
            <tr className="ttu">
                <td colSpan="2">Pedágio</td>
                <td align="right">{formatarReal(reserva.pedagio ? reserva.pedagio.toString() : '0')}</td>
            </tr>
            <tr className="ttu">
                <td colSpan="2">Taxa de serviço</td>
                <td align="right">{formatarReal(reserva.taxaServico ? reserva.taxaServico.toString() : '0')}</td>
            </tr>
            <tr className="ttu">
                <td colSpan="2">Desconto</td>
                <td align="right">{reserva.desconto ? formatarReal(reserva.desconto.toString()) : formatarReal('0')}</td>
            </tr>
            <tr className="ttu">
                <td colSpan="2">Valor total pago</td>
                <td align="right">{formatarReal(this.calcularValorPago(reserva).toString())}</td>
            </tr>
            <tr className="ttu">
                <td colSpan="2">Forma de pagamento</td>
                <td align="right">{reserva.descricaoFormasPagamento}</td>
            </tr>
        </React.Fragment> : null}
        </React.Fragment>

    }


    linha() {
        return <hr id='printPageButton' style={{
            borderStyle: 'dashed',
            borderWidth: 3,
        }} />
    }

    exibirCupomCancelamento(reserva) {
        return <div>
            <table className="printer-ticket">
                <thead>
                    {this.exibirCabecalho('Recibo de Cancelamento', reserva, false)}
                </thead>
                <tbody>
                    {this.exibirDadosRota(reserva)}
                    {this.exibirPassageiro(reserva, false)}
                </tbody>
                {this.exibirTotaisReserva(reserva, false)}
            </table>
            {this.linha()}
        </div>
    }

    exibirLimiteCupom() {
        return <div className='printer-element'>--</div>
    }

    exibirDireitoDeveres() {
        if (!EMPRESAS_NAO_EXIBIR_DIREITOS_DEVERES.includes(this.props.empresaSelecionada.id)) {
            return (
                <div>
                    {this.exibirLimiteCupom()}
                    <div className="printer-ticket" style={{textAlign: 'justify', padding: '5px'}}>          
                        {EMPRESA_POLITUR === this.props.empresaSelecionada.id ? <>
                            <div className='direitosEdeveres'>
                                <h2>Condições do transporte</h2><p>1. Os procedimentos de embarque são iniciados com 30 minutos de antecedência. O passageiro deve chegar até 15 minutos antes do horário de saída previsto na passagem. Caso chegue após esse tempo, estará sujeito a cancelamento da passagem.</p><p>2. Cada passageiro terá direito a levar 30kg de bagagem no bagageiro e 5kg de volume no porta-embrulho.</p><p>3. Os horários indicados na passagem são estimados e poderão variar a depender do trânsito, de condições climáticas e regras de embarcações nos terminais náuticos. A Politur não se responsabiliza por perdas de voos ou compromissos em razão de atrasos.</p><p>4. A Politur não se responsabiliza por itens sem supervisão deixados no interior dos veículos utilizados para a realização do transporte dos passageiros, bem como por quaisquer atos de terceiros.</p><p>5. Alterações, cancelamentos e reembolsos estarão sujeitos às seguintes penalidades:</p><ul><li>a) Até de 7 dias antes da viagem: 20% do preço da passagem.</li><li>b) Menos que 7 dias e mais que 48h antes da viagem: 50% do valor da passagem.</li><li>c) 48h ou menos antes da viagem: 100% do valor da passagem.</li></ul><p>6. As passagens são intransferíveis. Não é possível alterar o titular da passagem após a emissão.</p>
                            </div>
                        </>: <>
                            <div className='direitosEdeveres'>
                                <h2>DIREITOS DOS PASSAGEIROS</h2><p>I - ser transportado com pontualidade, segurança, higiene e conforto;</p><p>II - Transportar, gratuitamente, até 30 (trinta) quilos de bagagem no bagageiro e 5 (cinco) quilos de volume no porta-embrulho;</p><p>III - receber os comprovantes das bagagens transportadas no bagageiro e ser indenizado por extravio ou dano de bagagem transportada no bagageiro;</p> <p>IV - Receber a diferença do preço da passagem em veículos de características inferiores às daquele contratado;</p><p>V - Receber, às expensas da transportadora, alimentação e pousada, nos casos de venda de mais de um bilhete de passagem para a mesma poltrona ou interrupção/retardamento da viagem, após 3 (três) horas, em razão de defeito, falha ou outro motivo de responsabilidade da transportadora;</p><p></p>VI - Receber da transportadora, em caso de acidente, imediata e adequada assistência;<p>VII - optar, em caso de atraso por período superior a 1 (uma) hora, por: continuar a viagem em outra empresa às expensas da transportadora; ou receber de imed iato o valor do bilhete de passagem, em caso de desistência; ou continuar a viagem, pela mesma transportadora, que deverá dar continuidade à viagem num período máximo de 3 (três) horas após a interrupção;</p><p>VIII - remarcar o bilhete adquirido observado o prazo de um 1 (ano) de validade do bilhete a contar da data da primeira emissão. A partir de 3 (três) horas antes do início da viagem, é facultado à transportadora efetuar a cobrança de até 20% (vinte por cento) do valor da tarifa a título de remarcação.</p><p>IX - Transferir o bilhete adquirido, observado o prazo de 1 (um) ano de validade do bilhete a contar da data da primeira emissão.</p><p>X - Receber a importância paga no caso de desistência da viagem, desde que com antecedência mínima de 3 (três) horas em relação ao horário de partida constante do bilhete,facultado à transportadora o desconto de 5% (cinco por cento) do valor da tarifa;</p><p>XI - estar garantido pelo Seguro de Responsabilidade Civil contratado pela transportadora;</p><p>XII - não ser obrigado a adquirir seguro facultativo complementar de viagem.</p>    
                            </div>
                        </>}
                    </div>
                    {this.exibirLimiteCupom()}
                    {this.linha()}
                </div>
            )
        }
        return ''   
    }

    exibirRecibo() {        
        const { reservaSelecionada } = this.props;
        return <div className='col-md-12 d-flex justify-content-center'>
            <div>
                <div className="pagebreak" />
                {this.linha()}
                <div ref={this.props.componentRef}>
                    <div>
                        {reservaSelecionada.situacaoReserva === 'CANCELADO' ? this.exibirCupomCancelamento(reservaSelecionada) :
                            <div>
                                 <div>
                                    {this.exibirCupom('Via do passageiro', reservaSelecionada)}
                                    <div className="pagebreak" />
                                    {this.exibirCupom('Cupom de embarque', reservaSelecionada)}
                                    {reservaSelecionada.regraBilhete == 'REGRA_W2I' && <><div className="pagebreak"/>
                                        {this.exibirBilheteEmbarque('Bilhete de Embarque', reservaSelecionada)}</>}
                                </div>
                            </div>
                        }
                        {reservaSelecionada.passageiroDto.criancaDto && reservaSelecionada.situacaoReserva !== 'CANCELADO'
                            ? <div>
                                {this.exibirCupom('Via do passageiro', reservaSelecionada, 1, true)}
                                <div className="pagebreak" />
                                {this.exibirCupom('Cupom de embarque', reservaSelecionada, 1, true)}
                            </div> : null}
                    </div>
                </div>
            </div>
        </div>
    }

    render() {
        const { reservaSelecionada } = this.props;
        if (reservaSelecionada) {
            return (
                <React.Fragment>                    
                    {this.exibirRecibo()}                    
                </React.Fragment>
            )
        }
        return ''
    }

}

export const mapStateToProps = state => {    
    return state;
};

export default connect(mapStateToProps, {})(PaginaReciboReserva)
